/**
 * Uploads a file to the carnet in a specific document type.
 * @param {string} folderId - The folder ID.
 * @param {string} docType - The document type (entretien, ouvrage, factures, plans, diagnostic, photos, contrat).
 * @param {File} file - The file to upload.
 * @param {string} token - The user's auth token.
 * @param {string} prefix - The API base URL.
 * @returns {Promise<Object>} - The response from the backend.
 */
export const uploadToCarnet = async (folderId, docType, file, token, prefix) => {
  const url = `${prefix}folders/${folderId}/carnet/documents/${docType}`;

  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || "Error uploading document to carnet");
    }

    return await response.json();
  } catch (error) {
    console.error("Error uploading to carnet:", error);
    throw error;
  }
};

export default uploadToCarnet;
